import { FormField } from 'components/form';
import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';
import StatusLabel from 'components/status-label/StatusLabel';
import { GENDERS } from 'modules/entertainment-videos/constants';
import React from 'react';
import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./entertainment-video-genders.i18n.json'));

function translate(path: string) {
  return __t(`entertainmentVideoGenders${path}`);
}

export function EntertainmentVideoGenders({
  genders,
  isEditMode = false,
  onGendersChange
}: {
  genders: Array<string>,
  isEditMode?: boolean,
  onGendersChange?: (genders: Array<string>) => void
}) {
  if (isEditMode) {
    return (
      <FormField
        direction="column"
        showRequiredMark={false}
        showValidationIcon={false}
        fontSize="small"
      >
        <MixedSelectDropdown
          withRemovable
          withMulti
          name="genders"
          items={GENDERS.map((gender) => ({
            identifier: gender,
            value: gender,
            isDisabled: false,
            isFocused: false,
            label: translate(`.genders.${gender}`),
            isSelected: genders.includes(gender)
          }))}
          className="realm-outfit-details-edit__compact-select"
          onItemsToggle={(_, __, addedOption) => {
            if (addedOption?.value) {
              onGendersChange?.([...genders, addedOption.value]);
            }
          }}
          onItemsRemove={(_, __, removedOption) => {
            onGendersChange?.(
              genders.filter((g) => g !== removedOption?.value)
            );
          }}
          onItemsRemoveAll={() => {
            onGendersChange?.([]);
          }}
        />
      </FormField>
    );
  }

  return (
    <div style={{ display: 'flex', gap: '6px' }}>
      {genders.map((gender) => (
        <StatusLabel
          key={gender}
          label={translate(`.genders.${gender}`)}
          type="neutral"
          size="small"
        />
      ))}
    </div>
  );
}
